import { render } from "./BasketCard.vue?vue&type=template&id=c6f8d3e4"
import script from "./BasketCard.vue?vue&type=script&lang=js"
export * from "./BasketCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__